import { useCallback, useMemo } from 'react';
import { DEFAULT_ARRIVAL, DEFAULT_DEPARTURE } from './Constants';
import { TInternalValue } from './Types';
import { addMinutesToTime } from './Utils';

interface IUseGetDefaultTimeRageProps {
  defaultArrivalValue?: string;
  defaultDepartureValue?: string;
  timeLimitInMinutes?: number;
}

export const useGetDefaultTimeRange = ({
  defaultArrivalValue,
  defaultDepartureValue,
  timeLimitInMinutes,
}: IUseGetDefaultTimeRageProps) => {
  const getDefaultDeparture = useCallback(() => {
    if (timeLimitInMinutes && defaultArrivalValue) {
      return addMinutesToTime(defaultArrivalValue, timeLimitInMinutes);
    }
    if (timeLimitInMinutes) {
      return addMinutesToTime(DEFAULT_ARRIVAL, timeLimitInMinutes);
    }
    return defaultDepartureValue || DEFAULT_DEPARTURE;
  }, [timeLimitInMinutes, defaultArrivalValue, defaultDepartureValue]);

  return useMemo(
    () =>
      ({
        arrival: defaultArrivalValue ?? DEFAULT_ARRIVAL,
        departure: getDefaultDeparture(),
      }) satisfies TInternalValue,
    [defaultArrivalValue, getDefaultDeparture],
  );
};
